import React from 'react'
import { t, Trans } from '@lingui/macro'
import yotiIdAppLogo from '../../../../assets/yoti-id-logo.svg'
import LocalisedImage from '../../common/LocalisedImage'
import '../WhatIsYoti.scss'

const HEADING = t`What is Yoti?`
const DESCRIPTION = t`A secure, reusable Digital ID you can use to prove your identity or age.`

const WhatIsYotiHeader = () => (
  <div className="what-is-yoti__header">
    <div className="what-is-yoti__header__title">
      <div className="what-is-yoti__header__title__image">
        <LocalisedImage alt={t`Yoti Logo`} src={yotiIdAppLogo} />
      </div>
      <div className="what-is-yoti__header__title__heading">
        <h3><Trans id={HEADING} /></h3>
      </div>
    </div>
    <div className="what-is-yoti__header__subtitle">
      <p><Trans id={DESCRIPTION} /></p>
    </div>
  </div>
)

export default WhatIsYotiHeader
